import { sva } from "@mobsuccess-devops/styled-system/css";

export const styles = sva({
  slots: ["layout", "image", "imageContainer", "content", "text"],
  base: {
    layout: {
      display: "flex",
      gap: "md",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      size: "full",
      tablet: {
        flexDirection: "row",
      },
    },
    imageContainer: {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "end",
      alignItems: "center",
      tablet: {
        flexDirection: "row",
        flex: "2",
      },
    },
    image: {
      maxHeight: "250px",
    },
    content: {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      gap: "md",
      alignItems: "center",
      tablet: {
        alignItems: "start",
        flex: "3",
      },
    },
    text: {
      textAlign: "center",
      tablet: {
        textAlign: "start",
      },
    },
  },
});
